import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TeacherStudentListElement } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const retrieveTeacherStudents = createAsyncThunk<TeacherStudentListElement[], void, { extra: Partial<Dependencies> }>(
  "teachers/retrieveTeacherStudents",
  async (_: void, { extra: { teacherRepository } }) => {
    return teacherRepository!.all();
  },
);
